export const DARK_MODE_FOREGROUND_COLOR = '#0eb44d';
export const QR_CODE_SIZE = 142;
